import { useState } from "react";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_DJANGO_BACKEND;


const TrackingPage = () => {

  const [trackingNumber, setTrackingNumber] = useState("");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const [corporateTracks, setCorporateTracks] = useState([]);
  const [showCorporate, setShowCorporate] = useState(false);

  const [showCreateModal, setShowCreateModal] = useState(false);
  const [newTrackingNumber, setNewTrackingNumber] = useState("");
  const [editId, setEditId] = useState(null);
  const [editTrackingNumber, setEditTrackingNumber] = useState("");   


  // поиск одного трека
  const searchTracking = async () => {

    if (!trackingNumber.trim()) return;


    try {

      setLoading(true);


      const response = await axios.get(
        `${BASE_URL}/api/tracking/${trackingNumber}/`
      );


      setResult(response.data);


    } catch (error) {

      setResult({
        error: "Трек-номер не найден"
      });


    } finally {

      setLoading(false);

    }

  };



  // загрузка корпоративных номеров
  const loadCorporateTracks = async () => {

    try {

      setLoading(true);


      const response = await axios.get(
        `${BASE_URL}/api/tracking/`
      );


      setCorporateTracks(response.data);
      setShowCorporate(true);


    } catch(error) {

      console.log(error);


    } finally {

      setLoading(false);

    }

  };



    const createTracking = async () => {

        if (!newTrackingNumber.trim()) return;


        try {

            setLoading(true);


            await axios.post(
                `${BASE_URL}/api/tracking/create/`,
                {
                    tracking_number: newTrackingNumber
                }
            );


            setNewTrackingNumber("");
            setShowCreateModal(false);


            // обновляем список
            loadCorporateTracks();


        } catch(error) {


            alert(
                error.response?.data?.error ||
                "Ошибка создания"
            );


        } finally {

            setLoading(false);

        }

    };

const deleteTracking = async (id) => {

  if (!window.confirm("Удалить трек-номер?")) return;


  try {

    await axios.delete(
      `${BASE_URL}/api/tracking/manage/${id}/`
    );


    loadCorporateTracks();


  } catch(error) {

    alert(
      error.response?.data?.error ||
      "Ошибка удаления"
    );

  }

};



    const updateTracking = async () => {

    try {

        await axios.put(
        `${BASE_URL}/api/tracking/manage/${editId}/`,
        {
            tracking_number: editTrackingNumber
        }
        );


        setEditId(null);
        setEditTrackingNumber("");

        loadCorporateTracks();


    } catch(error) {

        alert(
        error.response?.data?.error ||
        "Ошибка редактирования"
        );

    }

    };




  // выбор номера из списка
  const selectTracking = (number) => {

    setTrackingNumber(number);
    setShowCorporate(false);

  };



  return (

    <div className="p-6">


      <h1 className="text-2xl font-bold mb-4">
        Отслеживание заказов
      </h1>



      <div className="flex gap-2 mb-4">


        <button

            onClick={() => setShowCreateModal(true)}

            className="bg-purple-600 text-white px-4 py-2 rounded"

        >

            Создать трек-номер

        </button>


        <input

          type="text"

          value={trackingNumber}

          onChange={(e)=>setTrackingNumber(e.target.value)}

          placeholder="Введите трек-номер"

          className="border rounded px-3 py-2 w-80"

        />



        <button

          onClick={searchTracking}

          className="bg-blue-600 text-white px-4 py-2 rounded"

        >

          Найти

        </button>



        <button

          onClick={loadCorporateTracks}

          className="bg-green-600 text-white px-4 py-2 rounded"

        >

          Просмотреть корпоративные трек-номера

        </button>



      </div>




      {loading && (

        <div className="mt-4">

          Загрузка...

        </div>

      )}






      {showCorporate && (

        <div className="mt-6">


          <h2 className="text-xl font-bold mb-3">

            Корпоративные трек-номера

          </h2>



          <div className="border rounded">


            {corporateTracks.map((item) => (

            <div
                key={item.id}
                className="flex justify-between items-center border-b px-4 py-3 hover:bg-gray-100"
            >

                {editId === item.id ? (

                <div className="flex gap-2 w-full">

                    <input
                    value={editTrackingNumber}
                    onChange={(e) => setEditTrackingNumber(e.target.value)}
                    className="border rounded px-2 py-1 flex-1"
                    />


                    <button
                    onClick={updateTracking}
                    className="bg-green-600 text-white px-3 rounded"
                    >
                    Сохранить
                    </button>


                    <button
                    onClick={() => {
                        setEditId(null);
                        setEditTrackingNumber("");
                    }}
                    className="bg-gray-400 text-white px-3 rounded"
                    >
                    Отмена
                    </button>

                </div>


                ) : (

                <>

                    <span>
                    {item.tracking_number}
                    </span>


                    <div className="flex gap-3">

                    <button
                        onClick={() => selectTracking(item.tracking_number)}
                        className="text-blue-600"
                    >
                        Выбрать
                    </button>


                    <button
                        onClick={() => {
                        setEditId(item.id);
                        setEditTrackingNumber(item.tracking_number);
                        }}
                        className="text-orange-600"
                    >
                        Редактировать
                    </button>


                    <button
                        onClick={() => deleteTracking(item.id)}
                        className="text-red-600"
                    >
                        Удалить
                    </button>

                    </div>

                </>

                )}

            </div>

            ))}


          </div>


        </div>

      )}






      {result && (

        <div className="mt-6">


          {result.error ? (


            <div className="text-red-600">

              {result.error}

            </div>


          ) : (


            <>


              <h2 className="font-bold text-lg">

                {result.tracking_number}

              </h2>



              <div className="mt-4">


                {result.history?.map((item,index)=>(


                  <div

                    key={index}

                    className="border-b py-2"

                  >


                    <div>

                      {item.status}

                    </div>



                    <div className="text-gray-500">

                      {item.date}

                    </div>



                  </div>


                ))}



              </div>


            </>


          )}


        </div>


      )}


        {showCreateModal && (

        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center">


            <div className="bg-white rounded-lg p-6 w-96">


                <h2 className="text-xl font-bold mb-4">

                    Создать трек-номер

                </h2>



                <input

                    type="text"

                    value={newTrackingNumber}

                    onChange={(e)=>
                        setNewTrackingNumber(e.target.value)
                    }

                    placeholder="Введите трек-номер"

                    className="border rounded px-3 py-2 w-full mb-4"

                />



                <div className="flex justify-end gap-2">


                    <button

                        onClick={()=>{
                            setShowCreateModal(false)
                        }}

                        className="px-4 py-2 border rounded"

                    >

                        Отмена

                    </button>



                    <button

                        onClick={createTracking}

                        className="bg-blue-600 text-white px-4 py-2 rounded"

                    >

                        Создать

                    </button>


                </div>


            </div>


        </div>

        )}


    </div>

  );

};


export default TrackingPage;